// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  worldId: __t.u64().name("world_id"),
  index: __t.u8(),
  locationIndex: __t.u8().name("location_index"),
  place: __t.i32(),
  size: __t.u8(),
  state: __t.u8(),
  name: __t.string(),
  epithet: __t.string(),
  text: __t.string(),
  inn: __t.string(),
  shop: __t.string(),
  smithy: __t.string(),
  temple: __t.string(),
  talkSig: __t.byteArray().name("talk_sig"),
  talkWriting: __t.bool().name("talk_writing"),
  alarm: __t.string(),
  alarmNpc: __t.u64().name("alarm_npc"),
  alarmOffer: __t.u64().name("alarm_offer"),
  troubles: __t.array(__t.string()),
  rolledWeek: __t.u64().name("rolled_week"),
  stockWeek: __t.u64().name("stock_week"),
  writtenAt: __t.timestamp().name("written_at"),
});
